import { render, staticRenderFns } from "./modalv2.vue?vue&type=template&id=08db7f35&scoped=true"
import script from "./modalv2.vue?vue&type=script&lang=js"
export * from "./modalv2.vue?vue&type=script&lang=js"
import style0 from "./modalv2.vue?vue&type=style&index=0&id=08db7f35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08db7f35",
  null
  
)

export default component.exports